import { lazy } from "react";
import * as route from "./constants";

const Home = lazy(() => import("../../screens/Home"));
const Login = lazy(() => import("../../screens/Login"));
const UIKit = lazy(() => import("../../screens/UIKit"));
const Live = lazy(() => import("../../screens/Live"));
const MatchDetail = lazy(() => import("../../screens/MatchDetail"));
const LiveResults = lazy(() => import("../../screens/LiveResults"));
const Fixture = lazy(() => import("../../screens/Fixture"));
const MatchResults = lazy(() => import("../../screens/MatchResults"));
const MultipleScreens = lazy(() => import("../../screens/MultipleScreens"));
const MultipleScreensDetail = lazy(() => import("../../screens/MultipleScreens/detail"));
const Status = lazy(() => import("../../screens/Status"));
const Keno = lazy(() => import("../../screens/Keno"));

export const routes = [
    {
        path: route.HOME,
        Component: Home,
        requireAuth: true,
    },
    {
        path: route.LOGIN,
        Component: Login,
    },
    {
        path: route.UI_KIT,
        Component: UIKit,
        requireAuth: true,
    },
    {
        path: route.LIVE,
        Component: Live,
        requireAuth: true,
    },
    {
        path: route.LIVE_INDEX,
        Component: Home,
        requireAuth: true,
    },
    {
        path: route.LIVE_PROGRAM_MARKET_LIST,
        Component: Live,
        requireAuth: true,
    },
    {
        path: route.LIVE_MATCH_DETAIL,
        Component: MatchDetail,
        requireAuth: true,
    },
    {
        path: route.LIVE_RESULTS,
        Component: LiveResults,
        requireAuth: true,
    },
    {
        path: route.FIXTURE,
        Component: Fixture,
        requireAuth: true,
    },
    {
        path: route.FIXTURE_INDEX,
        Component: Home,
        requireAuth: true,
    },
    {
        path: route.FIXTURE_PROGRAM_MARKET_LIST,
        Component: Fixture,
        requireAuth: true,
    },
    {
        path: route.MATCH_RESULTS,
        Component: MatchResults,
        requireAuth: true,
    },
    {
        path: route.MULTIPLE_SCREENS,
        Component: MultipleScreens,
        requireAuth: true,
    },
    {
        path: route.MULTIPLE_SCREENS_DETAILS,
        Component: MultipleScreensDetail,
        requireAuth: true,
    },
    {
        path: route.STATUS,
        Component: Status,
        requireAuth: true,
    },
    {
        path: route.KENO,
        Component: Keno,
        requireAuth: true,
    },
];
